<script setup>
const emit=defineEmits(['update:likes','update:isLiked']);
const props=defineProps(['entityType','entityId','comments','isLiked','likes','views','size']);
</script>
<template>
 <footer class="uo-post-counters">
  <slot name="reaction"><PostReaction v-bind="props" @update:likes="v=>emit('update:likes',v)" @update:isLiked="v=>emit('update:isLiked',v)" /></slot>
  <div class="uo-post-utilities">
   <span class="uo-counter" :aria-label="'Просмотров: '+(views || 0)"><svg-icon name="eye" width="20" height="20" />{{views || 0}}</span>
   <NuxtLink class="uo-btn uo-btn-quiet uo-post-comments" :to="'/feed/'+entityId+'#comments'" :aria-label="'Комментарии: '+(comments || 0)"><svg-icon name="chat-start" width="20" height="20" />{{comments || 0}}</NuxtLink>
   <template v-if="entityType==='Post'"><PostBookmark :post-id="entityId" /><PostShare :post-id="entityId" /></template>
  </div>
 </footer>
</template>
<style scoped>
.uo-post-utilities{margin-left:auto;display:flex;align-items:center;gap:var(--uo-spacing-1);min-width:0}
.uo-post-comments{padding-inline:var(--uo-spacing-2)}
.uo-post-utilities :deep(.uo-post-bookmark){margin-left:0}
@media(max-width:480px){.uo-post-counters{gap:var(--uo-spacing-1)}.uo-post-utilities{gap:0}.uo-post-comments{padding-inline:var(--uo-spacing-1)}}
</style>
